import { fromJS } from 'immutable';

import * as ActionTypes from '../constants/ActionTypes';

const initialState = fromJS({
  partners: {},
});

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCHED_TOPIC:
      return state.mergeIn(
        ['partners'],
        fromJS(action.payload.entities.partners),
      );

    default:
      return state;
  }
};
